module.exports = __webpack_public_path__ + "img/letter-x.194e8fe6.svg";